import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { ChurnFlowReasonInfoboxService } from '@core/churn-flow-logic';
import {
  ChurnFlowAlternativeSolution,
  ChurnFlowSolutionCardI,
  ChurnReason,
} from '@core/churn-flow-types';
import {
  ChurnFlowReasonTemplateComponent,
  ChurnFlowSolutionCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';
import { ChurnFlowReasonBaseComponent } from '../../components/churn-flow-reason-base.component';

@Component({
  selector: 'tlc-churn-unhelpful-support-page',
  templateUrl: './churn-unhelpful-support-page.component.html',
  styleUrls: ['./churn-unhelpful-support-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChurnFlowInsightsComponent,
    ChurnFlowReasonTemplateComponent,
    ChurnFlowSolutionCardComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ChurnUnhelpfulSupportPageComponent extends ChurnFlowReasonBaseComponent {
  protected readonly reason = ChurnReason.UnhelpfulSupport;
  public readonly infoboxMessage: Signal<string | undefined> = inject(
    ChurnFlowReasonInfoboxService,
  ).getReasonInfoboxMessage(ChurnReason.UnhelpfulSupport);

  public readonly contactSpecialist: ChurnFlowSolutionCardI = {
    iconVariant: 'dialog',
    title: this.t('tlc.churn_flow.steps.unhelpful_support.solutions.contact_specialist.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.unhelpful_support.solutions.contact_specialist.incentive_1'),
      this.t('tlc.churn_flow.steps.unhelpful_support.solutions.contact_specialist.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.unhelpful_support.solutions.contact_specialist.cta'),
  };

  public readonly joinTrainingSession: ChurnFlowSolutionCardI = {
    iconVariant: 'currency-exchange',
    title: this.t('tlc.churn_flow.steps.unhelpful_support.solutions.join_training_session.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.unhelpful_support.solutions.join_training_session.incentive_1'),
      this.t('tlc.churn_flow.steps.unhelpful_support.solutions.join_training_session.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.unhelpful_support.solutions.join_training_session.cta'),
  };

  public readonly exploreQuickStart: ChurnFlowSolutionCardI = {
    iconVariant: 'help',
    title: this.t('tlc.churn_flow.steps.unhelpful_support.solutions.explore_quick_start.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.unhelpful_support.solutions.explore_quick_start.incentive_1'),
      this.t('tlc.churn_flow.steps.unhelpful_support.solutions.explore_quick_start.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.unhelpful_support.solutions.explore_quick_start.cta'),
  };

  public contactSpecialistAction(): void {
    this.analytics.trackAlternativeSelected('schedule_call');
    this.openIntercom(
      this.t(
        'tlc.churn_flow.steps.unhelpful_support.solutions.contact_specialist.intercom_message',
      ),
    );
  }

  public trackAlternativeEvent(alternative: ChurnFlowAlternativeSolution): void {
    this.analytics.trackAlternativeSelected(alternative);
  }
}
